
const serviceCategories = {
  'svc.parking': 5,
  'svc.toilet': 6,
  'svc.lift': 7,
  'svc.atm': 8,
  'svc.escalator': 9,
  'svc.stairs': 10,
  'svc.taxi': 11,
  'svc.recycling': 12,
  'svc.train': 13,
  'svc.metro': 14,
  'svc.tram': 15,
  'svc.bus': 16,
  'svc.stop': 17,
  'svc.nurseryRoom': 18,
  'svc.notInUse': 19,
  'svc.info': 20,
  'svc.directory': 21,
  'svc.toiletAccessible': 22,
  'svc.bottleRecycling': 23,
  'svc.playground': 24,

  'svc.lockers': 100,
  'svc.park': 101,
  'svc.parcelPickup': 102,
  'svc.parkingMeter': 103,
  'svc.evCharging': 104
};

module.exports = serviceCategories;
